import { render } from "./LatestNewsCard.vue?vue&type=template&id=12921f0f"
import script from "./LatestNewsCard.vue?vue&type=script&lang=js"
export * from "./LatestNewsCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__